import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=d896af8c&scoped=true"
import script from "./CommonTable.vue?vue&type=script&lang=js"
export * from "./CommonTable.vue?vue&type=script&lang=js"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=d896af8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d896af8c",
  null
  
)

export default component.exports